"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _EventValidator = require("./EventValidator");
Object.keys(_EventValidator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EventValidator[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _EventValidator[key];
    }
  });
});